// Multicurrency helper for ajax cart - runs on cart open

function multiCurrencyCleanUp () {
  console.log ('Multicurrency run');
  var activeCurrency = Shopify.currency["active"];

  if (activeCurrency == 'AUD') {var useCurrency = '$'} 
  else if (activeCurrency == 'CAD') {var useCurrency = '$'}
  else if (activeCurrency == 'DKK') {var useCurrency = 'kr.'}
  else if (activeCurrency == 'EUR') {var useCurrency = '€'}
  else if (activeCurrency == 'GBP') {var useCurrency = '£'}
  else if (activeCurrency == 'HKD') {var useCurrency = '$'}
  else if (activeCurrency == 'JPY') {var useCurrency = '¥'}
  else if (activeCurrency == 'NZD') {var useCurrency = '$'}
  else if (activeCurrency == 'SGD') {var useCurrency = '$'}
  else if (activeCurrency == 'USD') {var useCurrency = '$'};

  //console.log (useCurrency);
 
  if (activeCurrency != 'GBP') {
    //console.log ('Currency not GBP');   
    $('.cart_money').each(function() {      
      var html = $(this).html().replace('£', useCurrency);
      console.log (html);
      $(this).html(html);  
    });
    
  } else {
    //console.log ('Currency is GBP'); 
  };
  
  
};

// function to reload page when page is package, to resolve cache issue on iPad when adding package items to basket
window.addEventListener( "pageshow", function ( event ) {
  // isproduct referenced in product-template, product-package and collection-template
  if (typeof isproduct !== 'undefined'){
    console.log ('its a product, enable back button reload function');
    var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
      if ( historyTraversal ) {
          //alert ('back button pressed reload cache');
            setTimeout(function() {
              // Handle page restore.  
                 window.location.reload();
              },
            1);
    }
  }
});

(function($){
  /* ====================== FRAME ===================== */
  var editorActive = false;

  /* ==================  EDITOR LOADER ================ */
  var frame = {
    sectionOpen: {
      newsletter : function() {newsletterPopup() },
      exitintent : function() { }
    },

    sectionClose: {
      newsletter: function() { ctaModal('close') },
      exitintent: function() { ctaModal('close') }
    },

    blockOpen: {
      meganav: function(editing, param) {meganav(editing, param)  }
    },

    blockClose: {
      meganav: function(editing, param) {meganav(editing, param)  }
    }
  }

  /* =================== EDITOR INIT =================== */
  /* DO SOMETHING WHEN SECTIONS IS ACTIVE */
  $(document).on('shopify:section:load', function(){
    editorActive = true;
  });

  /* SECTION OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:section:select', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId;
    if( frame.sectionOpen[sectionName] ){
      frame.sectionOpen[sectionName]();
    }
  });

  /* SECTION CLOSED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:section:deselect', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId;
    if( frame.sectionClose[sectionName] ){
      frame.sectionClose[sectionName]();
    }    
  });

  /* BLOCK OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:block:select', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId,
    blockEl = $(evt.target);

    if( frame.blockOpen[sectionName] ){
      frame.blockOpen[sectionName](blockEl, 'editing');
    }
  });

  /* BLOCK CLOSED: CHECK THE CLOSED LIST AND DO SOMETHING */
  $(document).on('shopify:block:deselect', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId,
    blockEl = $(evt.target);

    if( frame.blockClose[sectionName] ){
      frame.blockClose[sectionName](blockEl, 'close');
    }
  });

  /* ================== FRONTEND LOADER ================ */
  function themeInit() {
    // CORE MODULE INIT'S
    swatches();

    // CUSTOM MODULE INIT'S
    newsletterPopup();
    ajaxCart();
    meganav();
    customerRegister();

  };

  themeInit();

  function customerRegister() {
    var $submitBtn = $('#SubmitButton'),
    $password1 = $('#CreatePassword'),
    $password2 = $('#ConfirmPassword'),
    $errorPlaceholder = $('#FormErrors');

    $submitBtn.attr('disabled', 'disabled');

    $('#CreatePassword, #ConfirmPassword').on('keyup', function() {
      if ($password1.val() != '') {
        if ( $password1.val() !== $password2.val() ) {
          $submitBtn.attr('disabled', 'disabled');
          $errorPlaceholder.html('Passwords do not match');
        } else {
          $errorPlaceholder.html('');
          $submitBtn.removeAttr('disabled');
        }
      } else {
        $submitBtn.attr('disabled', 'disabled');
        $errorPlaceholder.html('Passwords do not match');
      }
    });
  }
  
  function scrollUpOnMobile() {
    if ($(window).width() <= 768) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      //console.log ('scroll to top');
    } 
  };

  /* ==================== GLOBAL CTA =================== */
  function ctaModal(selector, cName, type) {
    var cookieName = cName,
    cookieType = type,
    $selector  = $(selector);

    setTimeout(function(){
      if( modalState == false ){
        if( !Cookies.get(cookieName) || editorActive==true || cName == null ){
          modalState = cName;
          setTimeout(function(){ $selector.addClass('cta--show')}, 8000);
          setTimeout(function(){ 
            $selector.addClass('cta--animate');
            if ($('.cta--show')[0]) {
              scrollUpOnMobile();
              //console.log ('cta show exists');
            } else {
              //console.log ('cta show does not exists');
            };
          }, 8050);
        }
      }
    }, 600);

    if( selector == 'close' ){
      $('.cta').each(function(){
        $(this).removeClass('cta--animate');
        setTimeout(function(){ $(this).removeClass('cta--show')}, 1500);
      });
    }

    function ctaClose(el) {
      if( cookieType == 'temporary' ){
        Cookies.set(cookieName, 'close-'+cookieName, { expires: 1, path: '/' });
      } else {
        Cookies.remove(cookieName);
        setTimeout(function(){ Cookies.set(cookieName, 'permenant-'+cookieName, { expires: 365, path: '/' })}, 150);
      }
      modalState = false;
      $selector.removeClass('cta--animate');
      setTimeout(function(){ $selector.removeClass('cta--show')}, 1500);
    };

    if(cookieType == 'permenant') { ctaClose() }
    
      $selector.find('.cta__close').on('click', function(){
        //alert('close clicked');
        ctaClose($selector)
      });
    
      $('.cta--popup').on('click', function(event){
        event.stopPropagation();
        //alert('close clicked from bg');
        ctaClose($selector)
      });
    
      $('.cta__content-inner').on('click', function(event){
        //alert('newsletter content pressed stop propogation')
        event.stopPropagation();
      });
    
  };

  /* ================= AJAX NEWSLETTER ================= */
  function newsletterPopup() {
    ctaModal('#newsletter__cta', 'newsletter');

    $('.mc-embedded-subscribe').on('submit', function(e){
      e.preventDefault();
      
      if( $(this).hasClass('popup') ){
        var $wrapper = $('.cta__content-inner .cta__content');
        var wheresubmitted = "popup"; 
      } else if ( $(this).hasClass('banner') ) {
        var wheresubmitted = "banner";        
      } else if ( $(this).hasClass('footer') ) {
        
        var $wrapper = $('.site-footer__newsletter form');
        var wheresubmitted = "footer"; 
      }

      $.ajax({
        type        : $(this).attr('method'),
        url         : $(this).attr('action'),
        data        : $(this).serialize(),
        cache       : false,
        dataType    : 'json',
        contentType : "application/json; charset=utf-8",
        error       : function(err) { console.log("Could not connect to the registration server. Please try again later, or contact hello@wemakewebsites.com"); },
        success     : function(data) {
          if (data.result != "success") {
            if( wheresubmitted == "banner" ){
              console.log ('Email failed to load - Show fail text - Banner');
              $('.mc-embedded-failure-banner').toggleClass('mc-show').delay(5000).queue(function (){
                $('.mc-embedded-failure-banner').toggleClass('mc-show');
              });
            };
            if( wheresubmitted == "footer" ){
              console.log ('Email failed to load - Show fail text - Footer');
              $('.mc-embedded-failure-footer').fadeIn('slow', function () {
                console.log('hit me');
                $(this).delay(5000).fadeOut('slow');
              });
            };
            if( wheresubmitted == "popup" ){
              console.log ('Email failed to load - Show fail text - Popup');
              $wrapper.append('<span class="error">Sorry, this email is either incorrect or already exists on our system</span>');
            };
          } else {
            if( wheresubmitted == "banner" ){
              console.log ('Email Submitted - Show success text - Banner');
              $('.mc-embedded-confirm-banner').toggleClass('mc-show').delay(5000).queue(function (){
                $('.mc-embedded-confirm-banner').toggleClass('mc-show');
              }); 
            };
            if( wheresubmitted == "footer" ){
              console.log ('Email Submitted - Show success text - Footer');
              $('.mc-embedded-confirm-footer').fadeIn('slow', function () {
                console.log('hit me');
                $(this).delay(5000).fadeOut('slow');
              });
            };
            if( wheresubmitted == "popup" ){
              console.log ('Email Submitted - Show success text - Popup');
              $wrapper.find('.error').hide();
              setTimeout(function(){            
                $('.cta__content-pre-signup').hide();
                $('.cta__content-post-signup').show();
              }, 100 );
            };
          }
        }
      });
    });
    
    var pathname = window.location.pathname; // Returns path only
    var origin   = window.location.origin;   // Returns base URL
    
    $("#cta__voucher-apply").click(function() {
      //alert (origin + '/discount/' + newsletterDiscount + '?redirect=' + pathname);
      Cookies.set('newsletter', 'permenant-newsletter');
      Cookies.set('newsletter_voucher_set', 'permenant');
      window.location.replace(origin + '/discount/' + newsletterDiscount + '?redirect=' + pathname);
    });
    
  };
  
 


  /* ================= AJAX CART ================= */
  function ajaxCart(){
    var storeCurrency = Cookies.get('currency'),
    form = '.product-form',
    $cartToggleBtn = $('.site-header__cart'),
    $cartCloseBtn = $('.cart-ajax__close'),
    $cartCount = $('.site-header__cart-count'),
    cartSubmitBtn = '.product-form__cart-submit span',
    $cartBody = $('.cart-ajax'),
    $cartList = $('.cart-ajax__list')
    $cartRow = $('cart-ajax__row'),
    $cartRemove = $('.cart-ajax__remove'),
    $cartQuantity = '.cart-ajax__quantity-ico',
    $cartTotalPrice = $('.cart-ajax--total-price'),
    cartOpened = false,
    cartNoItems = $cartCount.attr('data-count'),
    $cartError = $('.product-form__item--error');

    function cartBuild() {
      $.getJSON( "/cart.js", function( data ) {
        items = data.items,
        cart  = [];

        $.each(items, function(i, item){
          var itemProps = '';
          if (item.properties !== null) {
            if (item.properties.package_id === undefined) {
              itemProps = '';
            } else {
              itemProps = item.properties.package_id;
            }
          }

          prodInfo = {
            image         : item.image,
            price         : item.price,
            title         : item.product_title,
            type          : item.product_type,
            vendor        : item.vendor,
            variant_title : item.variant_title,
            quantity      : item.quantity,
            properties    : itemProps,
            link          : item.handle,  
            variant_id    : item.variant_id
          }
          cart.push(prodInfo);
        });

        $cartList.html('');

        for (var i = 0; i < cart.length; i++) {
          var cartImage = '<div class="cart-ajax__image"><a href="/products/'+cart[i].link+'"><img src='+cart[i].image+' /></a></div>',
          cartPrice = '<p><span class="money cart_money">'+moneyFormatter.format(storeCurrency, (cart[i].price/100))+'</span></p>',
          cartQuantity = '<div class="cart-ajax__quantity"><span class="cart-ajax__quantity-ico cart-ajax__quantity-ico--plus">+</span><input class=cart-ajax__quantity-input type=number min=1 max=100 value='+cart[i].quantity+'><span class="cart-ajax__quantity-ico cart-ajax__quantity-ico--minus">-</span></div>',
          cartRemove = "<a href=# class=cart-ajax__remove>Remove</a>",
          variantTitle = cart[i].variant_title != null ? ' [ '+cart[i].variant_title+' ]' : '';

          if( cart[i].properties !== '' ) {
            var cartTitle = '<p><strong>'+cart[i].vendor+':</strong> '+cart[i].title+variantTitle+'</p>';
            if( cart[i].title.indexOf('ackage') > 0 || cart[i].title.indexOf('Deal') > 0 || cart[i].title.indexOf('Set') > 0 ) {
              var cartData = '<div class="cart-ajax__row cart-ajax__package cart-ajax__package-parent" data-variant-id="'+cart[i].variant_id+'" data-package-id="'+cart[i].properties+'" data-line='+(i+1)+'><div class="cart-ajax__data">'+cartImage+'<div class=cart-ajax__info>'+cartTitle+cartPrice+'</div><div class=cart-ajax__item-tools>'+cartRemove+'</div></div></div>';
            } else {
              var cartData = '<div class="cart-ajax__package cart-ajax__package-child" data-variant-id="'+cart[i].variant_id+'" data-package-id="'+cart[i].properties+'" text-left" data-line='+(i+1)+'><div class="cart-ajax__data">'+cartTitle+'</div></div>';
            }
          } else {
            var cartTitle = '<h5>'+cart[i].vendor+'</h5> <p>'+cart[i].title+' '+variantTitle+'</p>';
            var cartData = '<div class="cart-ajax__row" data-line='+(i+1)+'><div class="cart-ajax__data">'+cartImage+'<div class=cart-ajax__info>'+cartTitle+cartPrice+'</div><div class=cart-ajax__item-tools>'+cartQuantity+cartRemove+'</div></div></div>';
          }

          $cartList.append(cartData);

          
        }

        $cartTotalPrice.html('<span class="money cart_money">'+moneyFormatter.format(storeCurrency, (data.total_price/100))+'</span>');
  
        
        
        
        multiCurrencyCleanUp ();

      if( data.total_price >= 1501 ){ 
          $('.cart-ajax--shipping, .cart-ajax__delivery').hide();
        } else {
          $('.cart-ajax--shipping, .cart-ajax__delivery').show();
        }

        cartOpened = true;
      
      });
    };

    function cartClose(){
      $cartBody.removeClass('cart-ajax--fadeIn cart-ajax--show');
      cartOpened = false;
    }

    function cartOpen() {
      cartNoItems = $('body').attr('data-count');

      if( cartOpened != true ){ 
        cartBuild();

        if ( cartNoItems > 0 ) {
          $("html, body").animate({ scrollTop: 0 });
          $cartBody.addClass('cart-ajax--show');
          setTimeout(function(){ 
            $cartBody.addClass('cart-ajax--fadeIn');
          }, 250);

          $cartBody.on('click', function(){
            //clearTimeout(timer);
          });

          $(document).mouseup(function(e){
            var container = $cartBody;
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              cartClose();
            }
          });
        } else {
          cartClose();
        }
      } else {
        cartClose();
      }

      $.event.trigger({
        type: "convertCurrency"
      });
     
      
    };

    function cartRender() {
      $.getJSON( "/cart.js", function( data ) {
        var cartTotal = data.item_count;
        
        function cartCount(type) {
          $('body').attr('data-count', cartTotal);

          $cartCount.each(function(){
            $(this).html(cartTotal);
          });

          if( type == 'show' ) {
            $cartCount.addClass('site-header__cart-count--show');
          } else {
            $cartCount.removeClass('site-header__cart-count--show');
          }
        }

        cartTotal > 0 ? cartCount('show') : cartCount('hide');
        cartOpen();
       
      });
    };

    function cartQuantity(el, lineQuantity) {
      var $lineRow = el.parents('.cart-ajax__row'),
      lineNo = $lineRow.attr('data-line');

      if( $lineRow.hasClass('cart-ajax__package-parent') ){
        var deleteObj = {};
        var parentItemId = $lineRow.attr('data-package-id');

        $('.cart-ajax__package').each(function(){
          var itemProp = $(this).attr('data-package-id');
          if( parentItemId == itemProp ){
            deleteObj[$(this).attr('data-variant-id')] = 0;
          }
        });
        
        jQuery.post('/cart/update.js', {updates: deleteObj }, function() {
          $('.cart-ajax__package').addClass('cart-ajax__row--deleted');
          setTimeout(function(){
            if ( lineQuantity == 0 ) { $('.cart-ajax__package').remove(); }
            cartOpened = false;
            cartRender();
            $('.single-option-selector').trigger('change');
          }, 250);
        });
      } else {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + lineQuantity + '&line=' + lineNo,
          dataType: 'json',
          success: function(response){
            if ( lineQuantity == 0 ) { $lineRow.addClass('cart-ajax__row--deleted')}
              setTimeout(function(){
                if ( lineQuantity == 0 ) { $lineRow.remove(); }
                cartOpened = false;
                cartRender();
              }, 250);
          }
        });
      }
    };

    
    $cartToggleBtn.on('click', function(e){
      e.preventDefault();
      cartRender();
      $('.meganav').removeClass('meganav--show');
    });

    $cartCloseBtn.on('click', function(e){
      e.preventDefault();
      cartClose();
    });

    $('.package-submit').on('click', function(e){
      e.preventDefault();
    });

    $(document).on('submit', '.product-form', function(e){
      var $this = $(this);
      console.log($this.hasClass('.product-form--upsell'));
      if( $this.hasClass('product-form--upsell') ){
        //if this is the popup upsell go to the cart don't use ajaxcart
        return true;
      } else {
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: $this.serialize(),
          dataType: 'json',
          success: function(response){
            $('html').removeClass('scroll-lock');
            $('.modal').removeClass('modal--is-active');
            cartOpened = false;
            $this.addClass('product-form--submitted');
            $this.find(cartSubmitBtn).html("Added to basket");
            if( $('.product-single__variant-upsell').length > 0 ){
              if($this.hasClass('product-form--main')){
                var $content = $('.product-single__variant-upsell').html();
                var $buycontent = $('.product_purchased').html();
                var $combinedcontent = $buycontent + $content;
                $.featherlight($combinedcontent, {
                  afterOpen: function(){
                    var sections = new theme.Sections();
                    $('html, body').addClass('scroll-lock');
                    $this.find(cartSubmitBtn).html("Add to basket"); 
                    sections.register('product', theme.Product); 
                  },
                  afterClose: function(){
                    $('html, body').removeClass('scroll-lock');
                  }
                });
              } else {
                if( $('.featherlight-content').length > 0 ){
                  $.featherlight.current().close();
                }
              }
            }

            cartRender();
            $cartError.html('').hide();

            if( $('#package-id').length >= 1 ){
              //console.log ('package added');
              $('#package-id').val(parseInt($('#package-id').val()) + 1);
              $('a[href="#option_submit"]')
              .removeClass('product-package--added')
              .attr('data-package-item-selected', 'false')
              .text('Add to Package')
              .each(function(){
                validateOption(this);
              });
              
              //package upsell popup

              if( $('.product-single__variant-upsell').length > 0 ){
                console.log ('and has an upsell');
                var $content = $('.product-single__variant-upsell').html();
                var $buycontent = $('.product_purchased').html();
                var $combinedcontent = $buycontent + $content;
                $.featherlight($combinedcontent);

              }

              //package upsell popup end
              
            }

            setTimeout(function(){
              $this.find(cartSubmitBtn).html("Add to basket");
              $this.removeClass('product-form--submitted');
            }, 500);
          },
          error: function(xhr){
            console.log(xhr.responseText);
          }
        });
      }
    });

    $(document).on('mouseup', '.cart-ajax__remove', function(e){
      e.preventDefault();
      cartQuantity($(this), 0);
    });

    $(document).on('mouseup', $cartQuantity, function(e){
      e.preventDefault();
      var $input       = $(this).parent().find('input'),
      inputVal     = parseInt($input.val()),
      sendQuantity = 0;

      if( $(this).hasClass('cart-ajax__quantity-ico--plus') ){
        $input.val(inputVal+1);
        sendQuantity = inputVal+1;
      } else {
        if(inputVal-1 != 0){
          $input.val(inputVal-1);
          sendQuantity = inputVal-1;
        }
      }

      cartQuantity($(this), sendQuantity);
    });

      // $(document).on('mouseup', function(e){
      //   if (!$cartBody.is(e.target) && $cartBody.has(e.target).length === 0){ cartClose() }
      // });
      
    };

    /* ================= MEGA NAV ================= */
    function meganav(editing, param){
     var $siteNavList = $('.site-nav li'),
     $siteHeader = $('.site-header'),
     $siteDropdown = $('.meganav'),
     siteDropdownMobile = '.mobile-nav__item__dropdown',
     $siteDropdownMobileParent = $('.mobile-nav__item__parent'),
     $navbar = $('nav[role="navigation"]');

     /* SHOW IF EDITING */
     if(editing){
      if( param == 'editing'){
        editing.addClass('meganav--show');
      } else {
        editing.removeClass('meganav--show');
      }
    }

    $siteNavList.on('mouseenter', function(evt) {
      var $parentId     = $(this).data('meganav-parent'),
      $dropdownList = $('.meganav');

      $siteNavList.removeClass('meganav--active');
      $(this).addClass('meganav--active');
      $dropdownList.removeClass('meganav--show');
      $('.cart-ajax').removeClass('.cart-ajax--show cart-ajax--fadeIn')

      $dropdownList.each(function(){
        $(this).find('.meganav__col--list').last().addClass('meganav__col--list-last');

        var $childId = $(this).data('meganav-child');
        if( $parentId == $childId ){
          $(this).addClass("meganav--show").delay(1).queue(function(){
            $(".meganav--tablet-close").html("Shut").delay(1).html("Close").dequeue();
          });
          //NH had to queue a text update with a delay to force a second screen redraw to fix the menu not popping down on first click after load on ios since ios 11.4 update. Bizarre
        }
      });
    });

    $siteDropdown.on('mouseleave mousedown', function(e) {
      // Right Click Patch
      if( e.type != 'mousedown' && e.originalEvent.buttons != 2 ){
        $(this).removeClass('meganav--show');
        $siteNavList.removeClass('meganav--active');
      }
    });

    $navbar.on('mouseleave', function(e){
      if( e.target.className != 'site-nav__link site-nav__link--main' ) {
        $siteDropdown.removeClass('meganav--show');
        $siteNavList.removeClass('meganav--active');
      }
    });

    $siteDropdownMobileParent.on('click', function(e) {
      $('html,body').animate({ scrollTop:0 }, 0);

      
      console.log ('menu opened');
      var $this = $(this);
      
      if ($this.next(siteDropdownMobile).hasClass('mobile-nav__item__dropdown--show')) {
        //console.log ('child menu was open');
        $this.next(siteDropdownMobile).toggleClass('mobile-nav__item__dropdown--show');     
        setTimeout(function(){
          $('.mobile-nav-wrapper').animate({ scrollTop: 0}, 150);
        }, 220);
      } else {
        //console.log ('child menu was closed');
        $('.mobile-nav__item__dropdown--show').removeClass('mobile-nav__item__dropdown--show');
        $this.next(siteDropdownMobile).toggleClass('mobile-nav__item__dropdown--show');      
        setTimeout(function(){
          $('.mobile-nav-wrapper').animate({ scrollTop:0 }, 0);
          $('.mobile-nav-wrapper').animate({ scrollTop: $this.offset().top }, 150);
        }, 220);     
      }
    });

    // Scroll to top button
    $('.go-to-top__button').on('click', function(e){
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  }
  /* ================= SWATCHES ================= */
  function swatches(){
    $(document).ready(function(){
      $('.swatch').on('click', function(){
        $(this).find('input').prop('checked', true).trigger('change');
      });
    });
  }
      
})(jQuery);
    

/* ================= Newsletter Popup Handler ================= */

$(document).ready(function(){   
  if (Cookies.get('newsletter_fixed')) {
    //console.log ('have cookie, keep widget hidden');
  } else {
    //console.log ('no cookie, show widget');
    $('#newsletter_fixed').fadeIn();
  }

  $( "#newsletter_fixed" ).click(function() {
    //console.log ('button pressed');
    $('#newsletter__cta').addClass('cta--animate');
    $('#newsletter__cta').addClass('cta--show');
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $('#newsletter_fixed').fadeOut();
    Cookies.set('newsletter_fixed', 'permenant');
  });

});  
    
    
$(document).ready(function(){  
  if (Cookies.get('newsletter_voucher_confirm')) {
  } else {
    if (Cookies.get('newsletter_voucher_set')) {
      //alert ('newsletter has previously been opened display message');
      Cookies.set('newsletter_voucher_confirm', 'permenant');
      $('.newsletter__voucher-confirm').fadeIn().delay(2000).queue(function() {
        //alert(' fade out');
        $('.newsletter__voucher-confirm').fadeOut();
        $( this ).dequeue();
      });
    }
  }  
});
